import { Observable } from "rxjs";

import { ResponseEnvelope, makeResponseEnvelope } from "./response-envelope";
import { RestHttpParams } from "./rest-http.service";

export abstract class JsonApi<M> {
  abstract data: M[];

  getById(id: number): Observable<M> {
    return new Observable((observer) => {
      const result = this.data.find((item: any) => item.id === id);
      observer.next(result);
      observer.complete();
    });
  }

  getByFilter(params?: RestHttpParams): Observable<ResponseEnvelope<M>> {
    return new Observable((observer) => {
      if (params == null) {
        observer.next(makeResponseEnvelope(this.data, this.data.length));
      } else {
        const results = this.data.filter((item: any) => {
          return Object.keys(params).every((key) => item[key] === params[key]);
        });
        observer.next(makeResponseEnvelope(results, results.length));
      }
      observer.complete();
    });
  }
}
